// export const rootURL = "http://localhost/vijee-in/"; // dev
// export const rootURL = "http://vijee.in/server/"; // staging
export const rootURL = "./server/"; // production
export const cookieVariable = "VIJEE_IN_USER_DATA";